import { render, staticRenderFns } from "./certificationLogin.vue?vue&type=template&id=c6f4128c&scoped=true&"
import script from "./certificationLogin.vue?vue&type=script&lang=js&"
export * from "./certificationLogin.vue?vue&type=script&lang=js&"
import style0 from "./certificationLogin.vue?vue&type=style&index=0&id=c6f4128c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f4128c",
  null
  
)

export default component.exports